'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect } from 'react';
import { waitFor } from '../utils';
import { applyMiddleware } from '../utils/middleware';
/**
 * This initializes the global Segment middleware.  Two ways of initializing middlewares are needed
 * because any middleware created before segment is ready is not applied to events fired after, but events
 * that are fired before the ready event will be fired without middleware applied if we don't immediately initialize the middleware
 *
 * Will probably want to open a bug ticket with Segment to see if there is a way to prevent middleware from being removed when segment is ready
 * */
var useSegmentMiddleware = function () {
    useEffect(function () {
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, waitFor(function () { return window.analytics !== undefined; })];
                    case 1:
                        _a.sent();
                        window.analytics.ready(function () { return applyMiddleware(); });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Could not initialize analytic middlewares', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    // Applies middleware to events fired before segment is "ready".  These middleware are removed after segment is ready
    useEffect(function () {
        void (function () { return __awaiter(void 0, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, waitFor(function () { var _a; return ((_a = window.analytics) === null || _a === void 0 ? void 0 : _a.addSourceMiddleware) !== undefined; })];
                    case 1:
                        _a.sent();
                        applyMiddleware();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        console.error('Could not initialize analytic middlewares', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, []);
};
export default useSegmentMiddleware;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU2VnbWVudE1pZGRsZXdhcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvdXNlU2VnbWVudE1pZGRsZXdhcmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLFlBQVksQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUViLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFFbEMsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUNuQyxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0scUJBQXFCLENBQUM7QUFFdEQ7Ozs7OztLQU1LO0FBQ0wsSUFBTSxvQkFBb0IsR0FBRztJQUMzQixTQUFTLENBQUM7UUFDUixLQUFLLENBQUM7Ozs7Ozt3QkFFRixxQkFBTSxPQUFPLENBQUMsY0FBTSxPQUFBLE1BQU0sQ0FBQyxTQUFTLEtBQUssU0FBUyxFQUE5QixDQUE4QixDQUFDLEVBQUE7O3dCQUFuRCxTQUFtRCxDQUFDO3dCQUNwRCxNQUFNLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxjQUFNLE9BQUEsZUFBZSxFQUFFLEVBQWpCLENBQWlCLENBQUMsQ0FBQzs7Ozt3QkFFaEQsT0FBTyxDQUFDLEtBQUssQ0FBQywyQ0FBMkMsRUFBRSxHQUFDLENBQUMsQ0FBQzs7Ozs7YUFFakUsQ0FBQyxFQUFFLENBQUM7SUFDUCxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFFUCxxSEFBcUg7SUFDckgsU0FBUyxDQUFDO1FBQ1IsS0FBSyxDQUFDOzs7Ozs7d0JBRUYscUJBQU0sT0FBTyxDQUNYLHNCQUFNLE9BQUEsQ0FBQSxNQUFDLE1BQU0sQ0FBQyxTQUFpQiwwQ0FBRSxtQkFBbUIsTUFBSyxTQUFTLENBQUEsRUFBQSxDQUNuRSxFQUFBOzt3QkFGRCxTQUVDLENBQUM7d0JBQ0YsZUFBZSxFQUFFLENBQUM7Ozs7d0JBRWxCLE9BQU8sQ0FBQyxLQUFLLENBQUMsMkNBQTJDLEVBQUUsR0FBQyxDQUFDLENBQUM7Ozs7O2FBRWpFLENBQUMsRUFBRSxDQUFDO0lBQ1AsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBQ1QsQ0FBQyxDQUFDO0FBRUYsZUFBZSxvQkFBb0IsQ0FBQyJ9